// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. USE component-icon/src/svgtoreact.sh TO MODIFY
import React from 'react';
import PropTypes from 'prop-types';

var Script = function Script(_ref) {
  var className = _ref.className,
      label = _ref.label;
  return (
    /*#__PURE__*/
    React.createElement("svg", {
      className: className,
      "aria-label": label,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16"
    },
    /*#__PURE__*/
    React.createElement("path", {
      d: "M2.675 10.057Q2.675 8.7.629 8.7V7.307a2.844 2.844 0 001.543-.332 1.126 1.126 0 00.5-1.01V3.7a1.848 1.848 0 01.838-1.678 4.7 4.7 0 012.5-.536v1.328a2.273 2.273 0 00-1.273.34 1.061 1.061 0 00-.4.9V6.22q0 1.452-1.762 1.736v.087q1.762.264 1.762 1.729v2.181a1.075 1.075 0 00.392.9 2.156 2.156 0 001.277.322v1.335a4.562 4.562 0 01-2.558-.573 2.064 2.064 0 01-.781-1.805zM13.433 12.3a1.893 1.893 0 01-.766 1.67 4.452 4.452 0 01-2.451.547v-1.338a2.075 2.075 0 001.139-.281 1.053 1.053 0 00.407-.945v-1.911a2.051 2.051 0 01.408-1.364 2.167 2.167 0 011.354-.635v-.087q-1.762-.284-1.762-1.736V4.053a1.125 1.125 0 00-.35-.9 1.972 1.972 0 00-1.2-.34V1.487a4.2 4.2 0 012.466.558 2.127 2.127 0 01.75 1.827v2.093A1.126 1.126 0 0013.921 7a2.762 2.762 0 001.45.307V8.7a2.747 2.747 0 00-1.443.31 1.136 1.136 0 00-.5 1.047z"
    }))
  );
};

export default Script;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-icon/es/reactsvgs/Script.js
// module id = 1049
// module chunks = 0